(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordions"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const toggles = document.querySelectorAll(".hb-accordion-toggle");

    toggles.forEach(toggle => {
      toggle.addEventListener("click", function () {
        const accordion = this.closest(".hb-accordion");
        const container = this.closest(".accordions-content-box");
        accordion.classList.toggle("active");
        container.classList.toggle("active");
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
